import { inject } from '@angular/core';
import {
  callApiMethod,
  setError,
  setLoaded,
  setLoading,
  withResourceState,
} from '@kinet-open-network/client/shared/data-access/state';
import { patchState, signalStore, withMethods } from '@ngrx/signals';
import { BankPaymentsService } from '../services/bank-payments.service';

export const BankPaymentsStore = signalStore(
  { protectedState: false },
  withResourceState(BankPaymentsService, {
    query: {
      initial: {
        sort: ['-createdAt'],
      },
    },
  }),
  withMethods((store, service = inject(BankPaymentsService)) => ({
    sync: (id: string) => {
      patchState(store, setLoading());

      return callApiMethod(() => service.sync(id), {
        next: (model) => patchState(store, { model }, setLoaded()),
        error: (err) => patchState(store, setError(err)),
      });
    },
    cancel: (id: string) => {
      patchState(store, setLoading());

      return callApiMethod(() => service.cancel(id), {
        next: (model) => patchState(store, { model }, setLoaded()),
        error: (err) => patchState(store, setError(err)),
      });
    },
  })),
);
